// src/App.tsx
import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { SaveFlowProvider } from "./context/SaveFlowContext"; // Twój nowy context

// Importy widoków
import ThankYou from "./components/ThankYou";
import { categories } from "./coverData";
import CategorySelect from "./CategorySelect";
import CoverList from "./CoverList";

const App: React.FC = () => {
  return (
    // Owijamy wszystko w Provider, żeby modal działał wszędzie
    <SaveFlowProvider>
      <Router>
        <Routes>
          <Route path="/thank-you" element={<ThankYou />} />

          {/* USUNIĘTO :pdfNameFromUrl ze ścieżek poniżej */}
          <Route path="/start" element={<CategorySelect />} />
          
          {/* Tu też usuwamy parametr z URL */}
          <Route path="/kategoria/:categoryId" element={<CoverList />} />

          <Route path="/" element={<CategorySelect />} />

          {/* Generowanie tras dla okładek */}
          {categories.map((cat) => 
            cat.covers.map((cover) => {
              // USUNIĘTO :pdfNameFromUrl z końca ścieżki
              const pathPattern = cover.pathOverride 
                ? `${cover.pathOverride}`
                : `${cat.basePath}/${cover.id}`;

              const Component = cover.component;
              
              return (
                <Route 
                  key={`${cat.id}-${cover.id}`} 
                  path={pathPattern} 
                  element={<Component />} 
                />
              );
            })
          )}
        </Routes>
      </Router>
    </SaveFlowProvider>
  );
}

export default App;